module.exports = __webpack_public_path__ + "img/func_3_1.ea9afa5a.svg";